import { render, staticRenderFns } from "./VariantSifterAssociationsLdPlot.vue?vue&type=template&id=b3ce807a&scoped=true&"
import script from "./VariantSifterAssociationsLdPlot.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAssociationsLdPlot.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAssociationsLdPlot.vue?vue&type=style&index=0&id=b3ce807a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ce807a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3ce807a')) {
      api.createRecord('b3ce807a', component.options)
    } else {
      api.reload('b3ce807a', component.options)
    }
    module.hot.accept("./VariantSifterAssociationsLdPlot.vue?vue&type=template&id=b3ce807a&scoped=true&", function () {
      api.rerender('b3ce807a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAssociationsLdPlot.vue"
export default component.exports